import React from 'react';
// import Panel from '@/components/ui/Panel'; // We'll use direct styling for now

import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center text-center flex-grow animate-fadeIn">
      {/* Arcturian-themed main panel with inline styles */}
      <div 
        style={{
          position: 'relative',
          background: 'rgba(15, 23, 42, 0.9)', // Dark slate with transparency
          backdropFilter: 'blur(16px)',
          border: '1px solid rgba(59, 130, 246, 0.3)', // Blue border
          boxShadow: '0 25px 50px -12px rgba(59, 130, 246, 0.2)', // Blue glow shadow
          padding: '3rem',
          maxWidth: '42rem',
          borderRadius: '1rem',
          overflow: 'hidden'
        }}
      >
        {/* Subtle glow effect overlay */}
        <div 
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(to right, rgba(37, 99, 235, 0.1), rgba(147, 51, 234, 0.1), rgba(99, 102, 241, 0.1))',
            borderRadius: '1rem',
            pointerEvents: 'none'
          }}
        />
        
        {/* Content */}
        <div style={{ position: 'relative', zIndex: 10 }}>
          <h1 
            style={{
              fontSize: '3.75rem',
              fontWeight: 'bold',
              marginBottom: '1.5rem',
              background: 'linear-gradient(to right, #60a5fa, #a78bfa, #818cf8)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              color: 'transparent',
              lineHeight: '1.1'
            }}
          >
            Welcome to the Future
        </h1>
          
          <p 
            style={{
              fontSize: '1.25rem',
              color: '#dbeafe', // Light blue text
              marginBottom: '2rem',
              lineHeight: '1.7',
              opacity: 0.9
            }}
          >
          This is your Arcturian Next-Gen App. Explore the possibilities of cutting-edge web technology,
          seamlessly integrated for an unparalleled user experience.
        </p>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center' }}>
            <button
              onClick={() => navigate('/auth')}
              style={{
                background: 'linear-gradient(to right, #2563eb, #7c3aed)',
                color: 'white',
                padding: '0.75rem 1.5rem',
                borderRadius: '0.5rem',
                border: 'none',
                fontSize: '1.125rem',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 10px 15px -3px rgba(59, 130, 246, 0.25)',
                transition: 'all 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'linear-gradient(to right, #1d4ed8, #6d28d9)';
                e.currentTarget.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'linear-gradient(to right, #2563eb, #7c3aed)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              Get Started <ArrowRight size={20} />
            </button>
            
            <button
              onClick={() => window.open('https://github.com/your-repo-link', '_blank')}
              style={{
                background: 'rgba(30, 41, 59, 0.8)',
                color: '#dbeafe',
                padding: '0.75rem 1.5rem',
                borderRadius: '0.5rem',
                border: '1px solid rgba(96, 165, 250, 0.5)',
                fontSize: '1.125rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(51, 65, 85, 0.8)';
                e.currentTarget.style.borderColor = 'rgba(96, 165, 250, 0.7)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(30, 41, 59, 0.8)';
                e.currentTarget.style.borderColor = 'rgba(96, 165, 250, 0.5)';
              }}
            >
            Learn More
            </button>
          </div>
        </div>
        
        {/* Decorative pulsing stars */}
        <div 
          style={{
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            width: '8px',
            height: '8px',
            background: '#60a5fa',
            borderRadius: '50%',
            animation: 'pulse 2s infinite'
          }}
        />
        <div 
          style={{
            position: 'absolute',
            bottom: '1rem',
            left: '1rem',
            width: '4px',
            height: '4px',
            background: '#a78bfa',
            borderRadius: '50%',
            animation: 'pulse 2s infinite',
            animationDelay: '1s'
          }}
        />
        <div 
          style={{
            position: 'absolute',
            top: '50%',
            left: '1rem',
            width: '6px',
            height: '6px',
            background: '#818cf8',
            borderRadius: '50%',
            animation: 'pulse 2s infinite',
            animationDelay: '2s'
          }}
        />
      </div>
    </div>
  );
};

export default HomePage; 